import { type FeatureModule } from '@store/features/types';

import ruleBuildChatReducer from './chatSlice';
import { ruleBuildStreamingApi } from './streamingApi';

/**
 * Rule Build feature module definition
 *
 * Provides task-based workflow for creating, editing, and managing
 * compliance rules through AI-powered chat interface.
 */
export const ruleBuildFeature: FeatureModule = {
  // Basic feature identification
  id: 'ruleBuild',
  name: 'Rule Build',

  // Optional feature dependencies
  dependencies: [],

  // Feature reducers
  reducers: {
    'ruleBuild/chat': ruleBuildChatReducer,
    [ruleBuildStreamingApi.reducerPath]: ruleBuildStreamingApi.reducer,
  },

  // Streaming API middleware
  middleware: [ruleBuildStreamingApi.middleware],

  // Persistence configuration (enable when needed)
  persistence: { enabled: false },

  // Cross-tab sync (enable when needed)
  sync: { enabled: false },

  // Feature lifecycle hooks
  setup: _store => {
    // Setup code when feature is registered
    console.log('Rule Build feature initialized');
  },

  cleanup: _store => {
    // Cleanup code when feature is unregistered
    console.log('Rule Build feature cleaned up');
  },
};
